module.exports = __webpack_public_path__ + "static/Deliveroo-7b96171f6e5c7aa78efac61f96d144a3.jpg";